import { useEffect, useState } from "react";
import { Button, Card, Group, Select, Stack, Text, TextInput, Title } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useTranslation } from "react-i18next";

import { api } from "../../api/client";

type Grp = { chat_id: number; title: string };

export function TelegramGroupsTab() {
  const { t } = useTranslation();
  const [groups, setGroups] = useState<Grp[]>([]);
  const [acc, setAcc] = useState<string>("");
  const [act, setAct] = useState<string>("");

  async function load() {
    const [g, a, b] = await Promise.all([
      api.getKnownGroups().catch(() => ({ value: [] as Grp[] })),
      api.getSetting("telegram.accounting_chat_id").catch(() => ({ value: null })),
      api.getSetting("telegram.activation_chat_id").catch(() => ({ value: null })),
    ]);
    setGroups((g.value ?? []) as Grp[]);
    setAcc(a.value != null ? String(a.value) : "");
    setAct(b.value != null ? String(b.value) : "");
  }
  useEffect(() => { void load(); }, []);

  async function save(key: string, raw: string) {
    const val = raw.trim() === "" ? null : Number(raw.trim());
    if (raw.trim() !== "" && Number.isNaN(val)) {
      notifications.show({ color: "red", message: t("settings.telegramGroups.invalidId") });
      return;
    }
    await api.putSetting(key, val);
    notifications.show({ color: "green", message: t("settings.telegramGroups.saved") });
  }

  const opts = groups.map((g) => ({ value: String(g.chat_id), label: `${g.title} (${g.chat_id})` }));

  return (
    <Card withBorder>
      <Stack>
        <Title order={5}>{t("settings.telegramGroups.title")}</Title>
        <Text size="sm" c="dimmed">{t("settings.telegramGroups.help")}</Text>
        <Group align="end" wrap="wrap">
          <Select label={t("settings.telegramGroups.accounting")} data={opts} value={opts.find((o) => o.value === acc) ? acc : null}
            onChange={(v) => setAcc(v ?? "")} searchable clearable w={280} placeholder={t("settings.telegramGroups.pick")} />
          <TextInput label={t("settings.telegramGroups.orManual")} value={acc} onChange={(e) => setAcc(e.currentTarget.value)} w={160} />
          <Button onClick={() => void save("telegram.accounting_chat_id", acc)}>{t("settings.telegramGroups.save")}</Button>
        </Group>
        <Group align="end" wrap="wrap">
          <Select label={t("settings.telegramGroups.activation")} data={opts} value={opts.find((o) => o.value === act) ? act : null}
            onChange={(v) => setAct(v ?? "")} searchable clearable w={280} placeholder={t("settings.telegramGroups.pick")} />
          <TextInput label={t("settings.telegramGroups.orManual")} value={act} onChange={(e) => setAct(e.currentTarget.value)} w={160} />
          <Button onClick={() => void save("telegram.activation_chat_id", act)}>{t("settings.telegramGroups.save")}</Button>
        </Group>
        <Button variant="subtle" onClick={() => void load()} w="fit-content">{t("settings.telegramGroups.reload")}</Button>
      </Stack>
    </Card>
  );
}
